var version = require('../version')
var Util = require('../util')
var RequestMethod = require('../constants/requestMethod')
const { default: Core } = require('../../core/Core')

var PluginGettersMixin = {
  /**
   * Returns AccountCode
   *
   * @memberof npaw.Plugin.prototype
   */
  getAccountCode: function () {
    return Core.getInstance().getFastDataService().getAccountCode();
  },

  /**
   * Returns Username
   *
   * @memberof npaw.Plugin.prototype
   */
  getUsername: function () {
    return this.options['user.name'];
  },

  /**
   * Returns content's PluginVersion
   *
   * @memberof npaw.Plugin.prototype
   */
  getPluginVersion: function () {
    return Core.getPluginVersion();
  },

  /**
   * Returns requestNumber value, to prevent /data calls being cached
   *
   * @memberof npaw.Plugin.prototype
   */
  getRequestNumber: function () {
    return Math.random();
  },

  /** COMMONS GETTERS */

  getUserType: function () {
    return this.options['user.type'];
  },

  /**
   * Returns AnonymousUser
   *
   * @memberof npaw.Plugin.prototype
   */
  getAnonymousUser: function () {
    return this.options['user.anonymousId'];
  },

  /**
   * Get URL referer.
   *
   * @memberof npaw.Plugin.prototype
   */
  getReferer: function () {
    let ret = this.options.referer || '';
    if (!ret && typeof window !== 'undefined' && window.location) {
      ret = window.location.href;
    }
    return ret;
  },

  /**
   * Get URL referral.
   * Previous page url.
   * @memberof npaw.Plugin.prototype
   */
  getReferral: function () {
    let ret = this.options.referral || '';
    if (!ret && typeof document !== 'undefined') {
      ret = document.referrer;
    }
    return ret;
  },

  /**
   * Get Browser language
   *
   * @memberof npaw.Plugin.prototype
   */
  getLanguage: function () {
    let ret;
    if (typeof navigator !== 'undefined') {
      ret = navigator.language;
    }
    return ret;
  },

  /**
   * Get Screen resolution
   *
   * @memberof npaw.Plugin.prototype
   */
  getScreenResolution: function () {
    let ret;
    try {
      if (window && window.screen) {
        const devicePixelRatio = window.devicePixelRatio || 1;
        ret = (window.screen.width * devicePixelRatio) + 'x' + (window.screen.height * devicePixelRatio);
      }
    } catch (e) {}
    return ret;
  },

  /** Returns deviceInfo json
   *
   * @memberof npaw.Plugin.prototype
   */
  getDeviceInfo: function () {
    const info = {};
    if (this.getDeviceCode()) info.deviceCode = this.getDeviceCode();
    if (this.getModel()) info.model = this.getModel();
    if (this.getBrand()) info.brand = this.getBrand();
    if (this.getDeviceType()) info.deviceType = this.getDeviceType();
    if (this.getDeviceName()) info.deviceName = this.getDeviceName();
    if (this.getOsName()) info.osName = this.getOsName();
    if (this.getOsVersion()) info.osVersion = this.getOsVersion();
    if (this.getBrowserName()) info.browserName = this.getBrowserName();
    if (this.getBrowserVersion()) info.browserVersion = this.getBrowserVersion();
    if (this.getBrowserType()) info.browserType = this.getBrowserType();
    if (this.getBrowserEngine()) info.browserEngine = this.getBrowserEngine();
    return info !== {} ? info : undefined;
  },

  /**
   * Returns DeviceCode
   *
   * @memberof npaw.Plugin.prototype
   */
  getDeviceCode: function () {
    return this.options['device.code'];
  },

  /**
   * Returns Device model
   *
   * @memberof npaw.Plugin.prototype
   */
  getModel: function () {
    return this.options['device.model'];
  },

  /**
   * Returns Device brand
   *
   * @memberof npaw.Plugin.prototype
   */
  getBrand: function () {
    return this.options['device.brand'];
  },

  /**
   * Returns Device type
   *
   * @memberof npaw.Plugin.prototype
   */
  getDeviceType: function () {
    return this.options['device.type'];
  },

  /**
   * Returns Device name
   *
   * @memberof npaw.Plugin.prototype
   */
  getDeviceName: function () {
    return this.options['device.name'];
  },

  /**
   * Returns Device OS name
   *
   * @memberof npaw.Plugin.prototype
   */
  getOsName: function () {
    return this.options['device.osName'];
  },

  /**
   * Returns Device OS Version
   *
   * @memberof npaw.Plugin.prototype
   */
  getOsVersion: function () {
    return this.options['device.osVersion'];
  },

  /**
   * Returns Device browser name
   *
   * @memberof npaw.Plugin.prototype
   */
  getBrowserName: function () {
    return this.options['device.browserName'];
  },

  /**
   * Returns Device browser version
   *
   * @memberof npaw.Plugin.prototype
   */
  getBrowserVersion: function () {
    return this.options['device.browserVersion'];
  },

  /**
   * Returns Device browser type
   *
   * @memberof npaw.Plugin.prototype
   */
  getBrowserType: function () {
    return this.options['device.browserType'];
  },

  /**
   * Returns DeviceCode
   *
   * @memberof npaw.Plugin.prototype
   */
  getBrowserEngine: function () {
    return this.options['device.browserEngine'];
  },

  getIsBlocked: function () {
    return this.options['ad.blockerDetected'];
  },

  isMethodPostEnabled: function () {
    return this.options.method && this.options.method.toUpperCase() === RequestMethod.POST;
  },

  getDeviceUUID: function () {
    let id;
    if (!this.options['device.isAnonymous']) {
      id = this.options['device.id'] || this.uuidGenerator.getKey();
    }
    return id;
  },

  /**
   * Returns content's PluginVersion
   *
   * @memberof npaw.Plugin.prototype
   */
  getLibVersion: function () {
    return version;
  },

  getAppName: function () {
    return this.options['app.name'];
  },

  getAppReleaseVersion: function () {
    return this.options['app.releaseVersion'];
  },

  /**
   * Returns Ip
   *
   * @memberof npaw.Plugin.prototype
   */
  getIp: function () {
    return this.options['network.ip'];
  },

  /**
   * Returns Isp
   *
   * @memberof npaw.Plugin.prototype
   */
  getIsp: function () {
    return this.options['network.isp'];
  },

  /**
   * Returns ConnectionType
   *
   * @memberof npaw.Plugin.prototype
   */
  getConnectionType: function () {
    return this.options['network.connectionType'];
  },

  /** Returns EDID object
   *
   * @memberof npaw.Plugin.prototype
   */
  getEDID: function () {
    const edid = this.options['device.EDID'];
    return edid ? edid.toString() : undefined;
  },

  /**
   * Returns obfuscateIp option
   *
   * @memberof npaw.Plugin.prototype
   */
  getObfuscateIp: function () {
    return this.options['user.obfuscateIp'];
  },

  /**
   * Returns privacy protocol option
   *
   * @memberof npaw.Plugin.prototype
   */
  getPrivacyProtocol: function () {
    let ret = this.options['user.privacyProtocol'];
    if (typeof ret === 'string') {
      ret = ret.toLowerCase();
    }
    return ret === 'optin' || ret === 'optout' ? ret : undefined;
  },

  /**
   * Return custom dimensions
   *
   * @memberof npaw.Plugin.prototype
   */
  getCustomDimensions: function () {
    const dim = this.options['content.customDimensions'];
    return typeof dim === 'object' ? dim : undefined;
  },

  /**
   * Returns content's Extraparam1
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam1: function () {
    return this.options['content.customDimension.1'];
  },

  /**
   * Returns content's Extraparam2
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam2: function () {
    return this.options['content.customDimension.2'];
  },

  /**
   * Returns content's Extraparam3
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam3: function () {
    return this.options['content.customDimension.3'];
  },

  /**
   * Returns content's Extraparam4
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam4: function () {
    return this.options['content.customDimension.4'];
  },
  /**
   * Returns content's Extraparam5
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam5: function () {
    return this.options['content.customDimension.5'];
  },

  /**
   * Returns content's Extraparam6
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam6: function () {
    return this.options['content.customDimension.6'];
  },

  /**
   * Returns content's Extraparam7
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam7: function () {
    return this.options['content.customDimension.7'];
  },

  /**
   * Returns content's Extraparam8
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam8: function () {
    return this.options['content.customDimension.8'];
  },

  /**
   * Returns content's Extraparam9
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam9: function () {
    return this.options['content.customDimension.9'];
  },

  /**
   * Returns content's Extraparam10
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam10: function () {
    return this.options['content.customDimension.10'];
  },

  /**
   * Returns content's Extraparam11
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam11: function () {
    return this.options['content.customDimension.11'];
  },

  /**
   * Returns content's Extraparam12
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam12: function () {
    return this.options['content.customDimension.12'];
  },

  /**
   * Returns content's Extraparam13
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam13: function () {
    return this.options['content.customDimension.13'];
  },

  /**
   * Returns content's Extraparam14
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam14: function () {
    return this.options['content.customDimension.14'];
  },
  /**
   * Returns content's Extraparam15
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam15: function () {
    return this.options['content.customDimension.15'];
  },

  /**
   * Returns content's Extraparam16
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam16: function () {
    return this.options['content.customDimension.16'];
  },

  /**
   * Returns content's Extraparam17
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam17: function () {
    return this.options['content.customDimension.17'];
  },

  /**
   * Returns content's Extraparam18
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam18: function () {
    return this.options['content.customDimension.18'];
  },

  /**
   * Returns content's Extraparam19
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam19: function () {
    return this.options['content.customDimension.19'];
  },

  /**
   * Returns content's Extraparam20
   *
   * @memberof npaw.Plugin.prototype
   */
  getExtraparam20: function () {
    return this.options['content.customDimension.20'];
  },

  /**
   * Returns parse Manifest Flag
   *
   * @memberof npaw.Plugin.prototype
   */
  isParseManifest: function () {
    return this.options['parse.manifest'];
  },

  /**
   * Returns parse CdnNode Flag
   *
   * @memberof npaw.Plugin.prototype
   */
  isParseCdnNode: function () {
    return this.options['parse.cdnNode'];
  },

  /**
   * Returns parse cdn switch Flag
   *
   * @memberof npaw.Plugin.prototype
   */
  isCdnSwitch: function () {
    return this.options['parse.cdnSwitchHeader'];
  },

  /**
   * Returns Cdn list
   *
   * @memberof npaw.Plugin.prototype
   */
  getParseCdnNodeList: function () {
    return this.options['parse.cdnNode.list'];
  },

  /**
   * Returns Cdn header name
   *
   * @memberof npaw.Plugin.prototype
   */
  getParseCdnNodeNameHeader: function () {
    return this.options['parse.cdnNameHeader'];
  },

  /**
   * Returns header node name
   *
   * @memberof npaw.Plugin.prototype
   */
  getParseNodeHeader: function () {
    return this.options['parse.cdnNodeHeader'];
  },

  /**
   * Return if is possible to overwrite adapters-json
   *
   * @returns {boolean}
   */
  canOverwriteAdapters: function () {
    return Util.parseBoolean(this.options['adapters.overwrite']);
  },

  /**
   * Get defined Adapter properties
   * @returns {object}
   */
  getAdaptersProperties: function () {
    return this.options['adapters.properties'];
  },

  /**
   * Check if AppAnalytics has auto begin before plugin creation
   * @returns {boolean}
   */
  isAppAnalyticsAutoBegin: function () {
    return Util.parseBoolean(this.options['check.appAnalytics.autoBegin']);
  },

  /**
   * Is AppAnalytics enabled
   * @returns {boolean}
   */
  isAppAnalyticsEnabled: function () {
    return Util.parseBoolean(this.options['check.appAnalytics.enabled']);
  },

  /**
   * Is VideoAnalytics enabled
   * @returns {boolean}
   */
  isVideoAnalyticsEnabled: function () {
    return Util.parseBoolean(this.options['check.videoAnalytics.enabled']);
  },

  /**
   * Is Configuration Refresh from LMA
   * @returns {boolean}
   */
  isRefreshLMAConfigurationEnabled: function () {
    return Util.parseBoolean(this.options['lma.refresh.configuration.enabled']);
  },

  /**
   * Is Plugin Logs enabled (to report QA Tools additional info)
   * @returns {boolean|*}
   */
  isPluginLogsEnabled: function () {
    return Util.parseBoolean(this.options['debug.pluginLogs.enabled']);
  },

  /**
   * Is Player Event Logs enabled (to report QA Tools additional info)
   * @returns {boolean|*}
   */
  isPlayerLogsEnabled: function () {
    return Util.parseBoolean(this.options['debug.playerLogs.enabled']);
  },

  /**
   * Time to refresh configuration object from LMA
   * @returns {boolean}
   */
  refreshLMAConfigurationSeconds: function () {
    return this.options['lma.refresh.configuration.seconds'];
  },

  /**
   * Return if playhead monitor is enabled
   * @returns {boolean}
   */
  getPlayheadMonitorEnabled: function () {
    return this.options['playhead.monitor'];
  },

  /**
   * Return if readyState monitor/check method are enabled
   * @returns {boolean}
   */
  getReadyStateMonitorEnabled: function () {
    return this.options['readyState.monitor'];
  },

  getPageName: function () {
    return this.options['content.title'];
  }
};

module.exports = PluginGettersMixin;
